/**
 * 合同列表
 */
import React from 'react';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import Client from './client';//客户端
import Knight from './knight';//骑士端
import { removeSessionStorage, getSessionStorage } from '@/assets/js/storage';

class ContractList extends React.PureComponent {

    state = {
        tab: [
            { id: 1, label: '客户端' },
            { id: 2, label: '骑士端' },
        ],
        curTabID: 1,  // 默认显示的tab
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
        //缓存curTabID值，则渲染该tabID值下的内容
        let sessionpath = 'contract/contractlist/contractlistment';
        if (getSessionStorage(sessionpath)) {
            this.setState({
                curTabID: JSON.parse(getSessionStorage(sessionpath))
            }, () => {
                removeSessionStorage(sessionpath);
            });
        }
    }

    // Tab导航切换操作回调
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID });
    }

    // 渲染相应Tab导航下的内容 
    _renderPage = () => {
        const { curTabID } = this.state;
        switch (curTabID) {
            case 1:
                return <Client curTabID={this.state.curTabID} history={this.props.history} />;
            case 2:
                return <Knight curTabID={this.state.curTabID} history={this.props.history} />;
            default:
                return null;
        }
    }

    render() {
        return (
            <div className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                <div className={styles.tableContainer}>
                    {this._renderPage()}
                </div>
            </div>
        );
    }
}

ContractList.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect(null, { setBreadcrumbPaths, })(ContractList);
